import React from 'react'
import { Link } from 'react-router-dom'
import { ROUTES } from '@/app/app/routing/routes'
import { Card } from '@/common/ui/Card'
import Logo from '@/common/ui/Navbar/logo.svg'
import { Button } from '@/common/ui/Form/Button'

const ServerUnavailablePage: React.FC = () => {
    const handleReload = () => {
        window.location.reload()
    }

    return (
        <div className='min-h-screen bg-base-100 px-2'>
            <div className='flex min-h-screen items-center justify-center'>
                <div className='flex flex-col items-center justify-center gap-[3.125rem]'>
                    <Link to={ROUTES.APP} aria-label='Перейти на главную'>
                        <Logo className='h-[30px] w-[165px]' />
                    </Link>
                    <Card>
                        <div className='w-[23.125rem] flex flex-col items-center text-center gap-[1.875rem]'>
                            <div
                                className='flex h-16 w-16 items-center justify-center rounded-[1rem] bg-error/10 text-error'
                                aria-label='Server error icon'
                            >
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    fill='none'
                                    viewBox='0 0 24 24'
                                    strokeWidth='1.8'
                                    stroke='currentColor'
                                    className='h-8 w-8'
                                    aria-hidden='true'
                                >
                                    <path
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                        d='M12 9v3.75m0 3.75h.008v.008H12v-.008Zm8.25-3.75a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z'
                                    />
                                </svg>
                            </div>
                            <div className='flex flex-col gap-3'>
                                <h1 className='text-[1.25rem] font-medium'>Server is not available</h1>
                                <p className='text-sm text-base-content/70'>
                                    Не удалось получить данные с сервера. Обычно это временная проблема. Попробуйте
                                    обновить страницу через несколько секунд.
                                </p>
                            </div>
                            <div className='w-full flex flex-col gap-[0.625rem]'>
                                <Button
                                    type='button'
                                    variant='filled'
                                    emphasis='accent'
                                    size='xl'
                                    className='w-full'
                                    onClick={handleReload}
                                    aria-label='Обновить страницу'
                                >
                                    Обновить страницу
                                </Button>
                                <Button
                                    type='button'
                                    variant='ghost'
                                    emphasis='secondary'
                                    size='lg'
                                    className='w-full'
                                    as={Link}
                                    to={ROUTES.APP}
                                    aria-label='Перейти на главную страницу'
                                >
                                    На главную
                                </Button>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    )
}

export default ServerUnavailablePage
